<template lang="pug">
el-select.payment-method-select(v-model='inner_value')
  el-option(v-for='(method, key) in payment_methods', :key='method.name', :label='method.display', :value='method.name')
</template>

<script>
export default {
  name: 'payment-method-select',
  props: ['value'],
  data() {
    return {
      inner_value: null,
    }
  },
  computed: {
    payment_methods() {
      return this.$store.state.summary.payment_methods
    },
  },
  mounted() {
    this.inner_value = this.value
  },
  watch: {
    inner_value() {
      this.$emit('input', this.inner_value)
    },
  },
}
</script>



// WEBPACK FOOTER //
// PaymentMethodSelect.vue?54bc698e